import BaseFilter from 'components/Functional/Filters/BaseFilter';
import LiteratureSearch from 'components/Pages/LiteratureHub/LiteratureSearch';
import useFilters from 'hooks/useFilters';
import { AppliedFilters } from 'model/LiteratureHub';

type Options = {
  id: string;
  name: string;
  showAggregateCount: boolean;
  text: string;
};

type Filters = {
  displayName: string;
  id: string;
  options: Array<Options>;
};

type Props = {
  filters: Array<Filters>;
  appliedFilters: Array<AppliedFilters>;
  itemsPerPage: number;
};

const LiteratureFiltersSection = ({ filters, appliedFilters, itemsPerPage }: Props) => {
  const {
    formattedFilters,
    onOptionSelect,
    appliedOptions,
    allOptions,
    onClearFilterSelection,
    onResetUnAppliedOptions,
    isFetching,
    selectedOptions,
    onFilterApply,
    unApplyOptions,
  } = useFilters({ needFacets: false, filters, notShowAggregateCount: true });
  return (
    <div className="funds-filter px-2 py-5 px-md-5 mb-4 mb-lg-5 background-digital-light-grey">
      <LiteratureSearch appliedFilters={appliedFilters} itemsPerPage={itemsPerPage} />
      {formattedFilters.length && (
        <BaseFilter
          className="mt-4 mt-lg-5"
          filters={formattedFilters}
          isFetching={isFetching}
          showDatePicker={false}
          filterApply={onFilterApply}
          unApplyOptions={unApplyOptions}
          needAggregateCount={() => {}}
          onOptionSelect={onOptionSelect}
          appliedOptions={appliedOptions}
          allOptions={allOptions}
          onClearFilterSelection={onClearFilterSelection}
          onResetUnAppliedOptions={onResetUnAppliedOptions}
          selectedOptions={selectedOptions}
        />
      )}
    </div>
  );
};

export default LiteratureFiltersSection;
